module.exports = __webpack_public_path__ + "static/media/logo.cccb1496.svg";